<template>
  <div>
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>经纪人管理</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item">
          <el-button type="primary" size="small" @click="addInfoDepart" id="auto-0">添加经纪人</el-button>
        </div>
        <div class="toolbar-item fr">
          <el-button type="primary" size="small" :disabled="multiselectList.length == 0" @click="del(2)" id="auto-1"
            >删除</el-button
          >
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-2">
      <fe-table
        :tableData="agentData"
        :columns="columns"
        border
        :show-pagination="false"
        @selection-change="handleSelectionChange"
      >
        <template #selection>
          <el-table-column type="selection"></el-table-column>
        </template>
        <template #qrCodeSjbUrlFull="{ scope }">
          <div style="padding: 10px 0">
            <img :src="scope.row.qrCodeSjbUrlFull" width="60" height="60" alt="" />
            <a href="javascript:;" @click="downloadImg(scope.row)" class="font-green">下载</a>
          </div>
        </template>
        <template #handle="{ scope }">
          <el-button type="text" class="font-size12" @click="del(1, scope.row.agentCode)">删除</el-button>
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:2
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';

export default {
  mixins: [tableMixin],
  data() {
    return {
      columns: [
        { label: '经纪人名称', prop: 'agentName', 'min-width': 100 },
        { label: '联系电话', prop: 'agentMobile', 'min-width': 100 },
        { label: '专属二维码', prop: 'qrCodeSjbUrlFull', 'min-width': 100 },
        { label: '操作', prop: 'handle', 'min-width': 100 }
      ],
      tableOptions: {},
      axiosConfig: { url: api.companyAgentQuery },
      multiselectList: [],
      agentData: []
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    beforeResolve(result) {
      this.agentData = result;
      return true;
    },
    del(type, agentCode) {
      let agentCodeList = type == 1 ? [agentCode] : this.multiselectList.map(el => el.agentCode);
      this.$confirm('是否删除经纪人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await axios.post(api.removeCompanyAgent, { agentCodeList });
          this.$message.success('删除成功');
          this.handleSearch();
        })
        .catch(() => {});
    },
    addInfoDepart() {
      this.$router.push({ path: '/agentAdd' });
    },
    handleSelectionChange(val) {
      this.multiselectList = val;
    },
    async downloadImg(row) {
      let res = await axios.post(api.createStockQrImage, {
        type: 4,
        qrCodeSjbUrl: row.qrCodeSjbUrl,
        stockQrName: row.agentName
      });
      window.open(res.data.filePath);
    }
  }
};
</script>
